
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FieldValues, useForm } from 'react-hook-form';
import { object, string } from 'yup';

import Stack from '@mui/material/Stack'

import { AppModal } from '.';
import { IAppModal } from '../../../compiler/global.interface';
import { EHelperText } from '../../../utilitie/validation';
import { TextInput } from '../Input';
import { IAppModalProps } from './AppModal';

export interface IChangePasswordModalProps extends IAppModal, Omit<IAppModalProps, 'onConfirm'> {
    onConfirm?: (values: any) => any,
    loading?: boolean
}

export interface IChangePasswordFormValues{
    old_password:string,
    new_password:string
}

export default function ChangePasswordModal({ onConfirm, loading, ...other }: IChangePasswordModalProps) {

    const { control, handleSubmit, setError, clearErrors, formState: { isValid }, watch } = useForm<{
        old_password: string,
        new_password: string,
        confirm_new_password: string
    }>({
        mode: 'all',
        defaultValues: {
            old_password:'',
            new_password: '',
            confirm_new_password: ''
        },
        resolver: yupResolver(object().shape({
            old_password: string().required(EHelperText.REQUIRED),
            new_password: string().required(EHelperText.REQUIRED).notAllowSpace().min(6,EHelperText.MIN + 6).matches(/^(?=.*\d)/,EHelperText.MIN + 1 + ' ' + EHelperText.NUMERIC).matches(/[a-zA-Z]/,EHelperText.MIN + 1 + ' ' + EHelperText.LETTER),
            confirm_new_password: string().required(EHelperText.REQUIRED).notAllowSpace().min(6,EHelperText.MIN + 6).matches(/^(?=.*\d)/,EHelperText.MIN + 1 + ' ' + EHelperText.NUMERIC).matches(/[a-zA-Z]/,EHelperText.MIN + 1 + ' ' + EHelperText.LETTER)
        }))
    })

    const [disabledButton,setDisabledButton] = useState(true)

    const _handleSubmit = async (values: FieldValues) => {
        try{
            onConfirm?.(values)
        }catch(error){
            alert('error')
        }
    }

    useEffect(() => {
        if (watch('new_password') !== watch('confirm_new_password')) {
            setDisabledButton(true)
            setError('new_password', { type: 'match', message: EHelperText.MATCH_PASSWORD })
        } else {
            setDisabledButton(false)
            clearErrors('new_password')
        }
    }, [watch('new_password'),watch('confirm_new_password')])

    return (
        <AppModal {...other} disabled={{onConfirm:!isValid || disabledButton}} loading={loading} onConfirm={handleSubmit(_handleSubmit, error => console.error(error))} title={'เปลี่ยนรหัสผ่าน'}>
            <Stack spacing={3} component="form">
                <TextInput type="password" id='old_password' name='old_password' label='รหัสผ่านเก่า' control={control} autoComplete='off' />
                <TextInput type="password" id='new_password' name='new_password' label='รหัสผ่านใหม่ ( ขั้นต่ำ 6 ตัวอักษร, ประกอบด้วย ตัวเลข, ตัวอักษร )' autoComplete='off' control={control} />
                <TextInput type="password" id='confirm_new_password' name='confirm_new_password' label='ยืนยันรหัสผ่านใหม่' autoComplete='off' control={control} />
            </Stack>
        </AppModal>
    );
}
